
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604124594223",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "955",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M1039.92888889 21.94963001v970.90370333H-15.92888889v-970.90370333h1055.85777778zM305.68296334 792.60444445a60.6814811 60.6814811 0 1 0 0 121.36296334 60.6814811 60.6814811 0 0 0 0-121.36296334z m218.45333333 0a60.6814811 60.6814811 0 1 0 0 121.36296334 60.6814811 60.6814811 0 0 0 0-121.36296334z m218.45333334 0a60.6814811 60.6814811 0 1 0 0 121.36296334 60.6814811 60.6814811 0 0 0 0-121.36296334z m188.11259221-661.42814777H93.29777778v452.85376L379.47164445 367.83407446l324.76728888 235.68687331 226.46328889-165.61189888V131.17629668zM748.65777778 185.78963001a91.02222222 91.02222222 0 1 1 0 182.04444445 91.02222222 91.02222222 0 0 1 0-182.04444445z",
        "p-id": "956"
      }
    }
  ]
})
    }
  